import { FormikHelpers } from "formik";
import PhonecentersMaintenanceForm from "./PhonecentersMaintenanceForm";
import { useGetPhonecentersMaintenance } from "./api/getPhonecentersMaintenance";
import { useEditPhonecentersMaintenance } from "./api/editPhonecentersMaintenance";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditPhonecentersMaintenance = ({handleCloseModal, phonecentersMaintenanceId}: EditPhonecentersMaintenanceProps)  => {
  const getPhonecentersMaintenanceQuery = useGetPhonecentersMaintenance({phonecentersMaintenanceId: phonecentersMaintenanceId})
  const editPhonecentersMaintenanceMutation = useEditPhonecentersMaintenance({data: {}, phonecentersMaintenanceId});

  const handleSubmit = async (values: IPostEditPhonecentersMaintenance, { setSubmitting }: FormikHelpers<IPostEditPhonecentersMaintenance>): Promise<void> => {
    try {
      await editPhonecentersMaintenanceMutation.mutateAsync({
        data: values,
        phonecentersMaintenanceId: phonecentersMaintenanceId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getPhonecentersMaintenanceQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getPhonecentersMaintenanceQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Συντηρητή.</div>
    )
  }

  return (
    <>
      {!getPhonecentersMaintenanceQuery.isLoading && getPhonecentersMaintenanceQuery.data &&
        <PhonecentersMaintenanceForm initialValues={getPhonecentersMaintenanceQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditPhonecentersMaintenanceProps {
  phonecentersMaintenanceId: number;
  handleCloseModal: () => void;
}

export default EditPhonecentersMaintenance;